import { defineComponent as _defineComponent } from 'vue'
import departmentOptions from '@/utils/format-edit/departmentOptions.json'
import hopeIndustryOptions from '@/utils/format-edit/hopeIndustryOptions.json'
import hopeJobcategoryOptions from '@/utils/format-edit/hopeJobcategoryOptions.json'
import { useNewYagiofferFormatData } from '@/composables/format-edit/useNewYagiofferFormat'


export default /*#__PURE__*/_defineComponent({
  __name: 'NewYagiofferRequestsCard',
  props: {
    currentCardId: null
  },
  setup(__props: any) {



const formatData = useNewYagiofferFormatData()

return { __sfc: true,formatData, departmentOptions, hopeIndustryOptions, hopeJobcategoryOptions }
}

})